
import React from 'react';
import { MapPin } from 'lucide-react';

const ServiceAreasList = () => {
  const serviceAreas = [
    'Rocky Mount', 'Raleigh', 'Greenville', 'Wilson', 'Goldsboro', 'New Bern',
    'Tarboro', 'Zebulon', 'Nashville', 'Clayton', 'Knightdale', 'Wake Forest'
  ];

  return (
    <div className="mt-12">
      <h2 className="text-2xl font-bold mb-6 text-center">Service Areas</h2>
      <p className="text-lg mb-6 text-center">
        We're proud to serve homeowners throughout Eastern North Carolina.
      </p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {serviceAreas.map((city) => (
          <div key={city} className="bg-gray-100 p-4 rounded-lg flex items-center">
            <MapPin className="h-5 w-5 text-primary mr-2" />
            <span>{city}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServiceAreasList;
